import { PlayerModel } from '@toilet-paper-games/core';
import { makeAutoObservable, reaction, toJS } from 'mobx';
import { ControllerUserModel } from './ControllerUserModel';

export class ControllerPlayerModelHandler {
  playerModel: PlayerModel;

  destructors: (() => void)[] = [];

  constructor(private user: ControllerUserModel) {
    this.playerModel = PlayerModel.fromDto({ ...user.playerInfo, ready: false });

    makeAutoObservable(this, {}, { autoBind: true });
  }

  destroy() {
    for (const destructor of this.destructors) {
      destructor();
    }
  }

  // if userModel is updated, update playerModel
  setupReaction() {
    this.destructors.push(
      reaction(
        () => toJS(this.user.playerInfo),
        (data) => {
          // Note: If playerModel get new properties, add them here
          this.playerModel.active = data.active;
          this.playerModel.image = data.image;
          this.playerModel.isHost = data.isHost;
          this.playerModel.screenName = data.screenName;
          this.playerModel.subscription = data.subscription;
          this.playerModel.hasConnection = data.hasConnection;
        },
        {
          fireImmediately: true,
        },
      ),
    );

    this.destructors.push(
      reaction(
        () => this.user.hasConnection,
        (hasConnection) => {
          if (!hasConnection) {
            this.playerModel.ready = false;
          }
        },
        {
          fireImmediately: true,
        },
      ),
    );
  }
}
